import React, { useEffect } from "react";

const TITLE_FLASH_MS = 5000;

function playCompletionChime() {
  try {
    const AudioContextCtor = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioContextCtor) {
      return;
    }

    const ctx = new AudioContextCtor();
    const play = () => {
      [523, 784].forEach((freq, i) => {
        const startAt = ctx.currentTime + i * 0.15;
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();

        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.frequency.value = freq;
        osc.type = "sine";
        gain.gain.setValueAtTime(0.001, startAt);
        gain.gain.exponentialRampToValueAtTime(0.4, startAt + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.001, startAt + 0.3);
        osc.start(startAt);
        osc.stop(startAt + 0.32);
      });
    };

    const resumePromise = ctx.state === "suspended" ? ctx.resume?.() : undefined;
    if (resumePromise) {
      void resumePromise.then(play).catch(() => undefined);
    } else {
      play();
    }

    window.setTimeout(() => {
      void ctx.close?.();
    }, 900);
  } catch {
    // Audio not supported or blocked - silently skip.
  }
}

/** Plays completion chime and briefly prefixes the tab title; no visual overlay. */
export const DashboardBuildCompletionConfetti: React.FC = () => {
  useEffect(() => {
    playCompletionChime();

    const previousTitle = document.title;
    document.title = `✅ ${previousTitle}`;
    const timeoutId = window.setTimeout(() => {
      document.title = previousTitle;
    }, TITLE_FLASH_MS);

    return () => {
      window.clearTimeout(timeoutId);
      document.title = previousTitle;
    };
  }, []);

  return null;
};
